import { useRef } from 'react';
import useScrollReveal from '../../hooks/useScrollReveal';
import styles from './fourthScreen.module.css';
import SmallBox from '../../components/smallbox/smallbox';
import globeIcon from '../../icons/globe.json';
import shieldIcon from '../../icons/shield.json';
import moneybagIcon from '../../icons/moneybag.json';

const learnedCards = [
  {
    icon: globeIcon,
    text: 'איך באמת מתחילים',
    desc: 'צעד אחרי צעד, בלי להרגיש אבודה - מהיום הראשון ועד הלקוחה הראשונה',
  },
  {
    icon: shieldIcon,
    text: 'איך בונים ביטחון',
    desc: 'מיינדסט של מנצחת - ארגז כלים מנטלי שיעזור לך להתמודד עם ספקות ופחדים',
  },
  {
    icon: moneybagIcon,
    text: 'איך מגיעות ללקוחות',
    desc: 'שיווק נכון, נוכחות דיגיטלית ובידול שיגרום ללקוחות לבחור דווקא בך',
  },
  {
    icon: shieldIcon,
    text: 'איך לא נשברים בדרך',
    desc: 'הסוד שהפריד בין מי שהצליחה לבין מי שנשארה עם תעודה במגירה',
  },
];

function FourthScreen() {
  const sectionRef = useRef(null);
  useScrollReveal(sectionRef);

  return (
    <section className={styles.learned} ref={sectionRef}>
      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.mainTitle} data-sr="0">
            את כל מה שלמדתי -{' '}
            <em className={styles.highlight}>ריכזתי בקורסים שלי</em>
          </h1>

          <p className={styles.subtitle} data-sr="0.07">
            לא רק טכניקה נכונה - אלא את כל מה שצריך כדי לצאת לדרך בביטחון
          </p>

          <div className={styles.smallBoxGrid} data-sr="0.12">
            {learnedCards.map((card, i) => (
              <SmallBox key={i} icon={card.icon} text={card.text} desc={card.desc} />
            ))}
          </div>

          <div className={styles.textBlock} data-sr="0.16">
            <h2 className={styles.bigTitle}>
              הבנתי בדיוק מה כל אחת בתחילת הדרך צריכה כדי למלא את היומן שלה.
            </h2>
            <h3 className={styles.ctaTitle}>
              בחרי את המסלול שמתאים לך ובואי נתחיל ↓
            </h3>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FourthScreen;
